

<template>
  <div class="bg-darker full-view" style="background-color: white">
    <div class="background">
      <div class="layer">
        <b-container fluid class="mt-5">
          <b-row>
            <b-col sm="12" md="12">
              <h1 class="mb-2 mt-5 content-center">Who are we?</h1>
            </b-col>
            <b-col offset-md="1" sm="12" md="10">
              <h5 class="mb-2 mt-5">
                The mission of the Danish Covid-19 Genome Consortium (DCGC) is
                to assist public health authorities to monitor the spread of
                SARS-CoV-2. The project was established in March 2020 through
                the coordinated effort of Aalborg University, Statens Serum
                Institute, Hvidovre Hospital, and Aalborg University Hospital.
                Large-scale SARS-CoV-2 sequencing capacity was initially
                established at Aalborg University and local sequencing capacity
                at Statens Serum Institute and Hvidovre Hospital. Since June 2020,
                the consortium has established additional local sequencing nodes
                at Aalborg University Hospital, Aarhus University Hospital,
                Slagelse Hospital, Rigshospitalet, Sygehus Lillebælt, and Odense
                University Hospital.
              </h5>
            </b-col>
          </b-row>
          <b-row style="margin-top: 5%">
            <b-col offset-md="1" sm="12" md="10">
              <span>Last update: {{stats_last_update}}</span>
            </b-col>
          </b-row>
          <b-row>
            <b-col offset-md="1" sm="12" md="10">
              <b-row align-h="around">
                <Stat
                  title="Sequenced Samples"
                  :number="stats_sequenced"
                  icon_name="diagram3-fill"
                ></Stat>
                <CustomStat
                  title="High-quality Genomes"
                  :number="stats_genomes"
                  icon_filename="rna.png"
                ></CustomStat>
                <Stat
                  title="Uploaded to public DB's"
                  :number="stats_uploaded"
                  icon_name="cloud-arrow-up"
                ></Stat>
              </b-row>
            </b-col>
          </b-row>
          <b-row style="margin-top: 5%">
            <b-col offset-md="1" sm="12" md="10">
              <h5>
                The consortium receives SARS-CoV-2 positive samples from both
                pillars of testing in Denmark.
              </h5>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
  </div>
</template>

<!-- Google tag (gtag.js) -->
<script async src="https://www.googletagmanager.com/gtag/js?id=G-FMSCKCLYDG"></script>
<script>
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'G-FMSCKCLYDG');
</script>

<script>
import Stat from "@/components/Stat.vue";
import CustomStat from "@/components/CustomStat.vue";

import stats_data from "../../public/stats.json";
import {
  get_number_of_all_samples,
  get_number_of_sequenced_samples,
} from "../preprocessing/graph_data";
export default {
  components: { Stat, CustomStat },
  computed: {
    stats_received: function () {
      return stats_data["Recieved"];
    },
    stats_sequenced: function () {
      return stats_data["Sequenced"];
    },
    stats_genomes: function () {
      return stats_data["Genomes"];
    },
    stats_uploaded: function () {
      return stats_data["Uploaded"];
    },
    stats_last_update: function () {
      return stats_data["LastUpdate"]
    }
  },
  methods: {
    all_samples() {
      return get_number_of_all_samples();
    },
    seq_samples() {
      return get_number_of_sequenced_samples();
    },
  },
};
</script>

<style>
.background {
  background: url("../assets/virus.png") no-repeat center center fixed;
  background-size: cover;
  position: relative;
  height: 100vw;
}

@media only screen and (min-width: 768px) and (max-width: 1200px) {
  .background {
    height: 130vw;
    background: url("../assets/virus.png") no-repeat center center fixed;
    background-size: cover;
  }
}

@media only screen and (min-width: 480px) and (max-width: 767px) {
  .background {
    height: 300vw;
    background: url("../assets/virus.png") no-repeat center center fixed;
    background-size: cover;
  }
}

@media only screen and (max-width: 479px) {
  .background {
    height: 500vw;
    background: url("../assets/virus.png") no-repeat center center fixed;
    background-size: cover;
  }
}

.layer {
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>